import { useCollaborationNotesPanel } from '~publish/components/PostDialogs/PostDetailsContent/useCollaborationNotesPanel'

/**
 * The Note counts a Post list's screen renders: `unread` for an unread
 * indicator, `notesButton` when it renders the queue card's Notes button,
 * which also shows the unread mention count and hides on a Post with no
 * Notes. The total runs its own backend count, so a list that does not
 * render that button never selects it.
 */
export type NoteCountSelection = 'none' | 'unread' | 'notesButton'

export function useNoteCountVariables(selection: NoteCountSelection): {
  includeUnreadNoteCount: boolean
  includeNotesButtonCounts: boolean
} {
  const { showPanel } = useCollaborationNotesPanel()
  return {
    includeUnreadNoteCount: showPanel && selection !== 'none',
    includeNotesButtonCounts: showPanel && selection === 'notesButton',
  }
}
